import React from 'react';

import {Result} from './Result';
import {ApiResultSuccess} from './ApiResultSuccess';

interface ApiResultProps {
  result: any;
  failedTitle?: string;
}

const ErrorMessage = ({result}: any) => {
  let error: string = '';

  if (result?.value?.response_json?.hasOwnProperty('error')) {
    error = result?.value?.response_json?.error;
  }
  if (!error && result?.value?.response_json?.hasOwnProperty('exception')) {
    error = result?.value?.response_json?.exception;
  }

  return <>{error || 'Unknown Error'}</>;
};

export const ApiResult = ({
  result,
  failedTitle = 'RUN failed',
}: ApiResultProps) => {
  /*
   * Common result element used when the response comes from an API request
   */

  return (
    <Result
      result={result}
      successElement={<ApiResultSuccess result={result}/>}
      failedTitle={failedTitle}
      failedDescription={<ErrorMessage result={result}/>}
    />
  );
};
